export const VideoServiceTokens = Object.freeze({
    VideoServiceProvider: Symbol('VideoServiceProvider'),
    VimeoApiClient: Symbol('VimeoApiClient'),
    TwentyThreeApiClient: Symbol('TwentyThreeApiClient'),
    TwentyThreeVideoService: Symbol('TwentyThreeVideoService'),
    VimeoVideoService: Symbol('VimeoVideoService'),
} as const);
